import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-12 md:py-16 bg-background-50">
      <div className="section-container">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="section-title">常见问题</h2>
          <p className="section-subtitle">关于51吃瓜每日大赛，你想知道的都在这里</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3 md:space-y-4">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-white rounded-xl border border-background-200 overflow-hidden"
            >
              <div className="p-4 md:p-6">
                <h3 className="text-base md:text-lg font-bold text-foreground-950 flex items-start gap-3">
                  <span className="text-primary-500 flex-shrink-0 font-heading text-xl">Q</span>
                  <span>{item.question}</span>
                </h3>
                <div className="mt-3 pl-8">
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                    <span className="text-accent-500 font-bold mr-2">A</span>
                    {item.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}